import {
  Avatar,
  Button,
  Dialog,
  Slide,
  TableCell,
  styled
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { ReactElement, Ref, forwardRef } from 'react';

export const AvatarError = styled(Avatar)(
  ({ theme }) => `
    background-color: ${theme.colors.error.lighter};
    color: ${theme.colors.error.main};
    width: ${theme.spacing(12)};
    height: ${theme.spacing(12)};

    .MuiSvgIcon-root {
      font-size: ${theme.typography.pxToRem(45)};
    }
  `
);

export const AvatarSuccess = styled(Avatar)(
  ({ theme }) => `
    background-color: ${theme.colors.primary.lighter};
    color: ${theme.colors.primary.main};
    width: ${theme.spacing(12)};
    height: ${theme.spacing(12)};

    .MuiSvgIcon-root {
      font-size: ${theme.typography.pxToRem(45)};
    }
  `
);

export const ButtonError = styled(Button)(
  ({ theme }) => `
    background: ${theme.colors.error.main};
    color: ${theme.palette.error.contrastText};
    width:15%;

    &:hover {
      background: ${theme.colors.error.dark};
    }
  `
);

export const ArchiveButtonError = styled(Button)(
  ({ theme }) => `
    background: ${theme.colors.error.main};
    color: ${theme.palette.error.contrastText};

    &:hover {
      background: ${theme.colors.error.dark};
    }
  `
);

export const ArchiveButtonSuccess = styled(Button)(
  ({ theme }) => `
    background: ${theme.colors.primary.main};
    color: ${theme.palette.primary.contrastText};

    &:hover {
      background: ${theme.colors.primary.dark};
    }
  `
);

export const ButtonSuccess = styled(Button)(
  ({ theme }) => `
    background: ${theme.colors.success.main};
    color: ${theme.palette.success.contrastText};
    width:15%;

    &:hover {
      background: ${theme.colors.success.dark};
    }
  `
);

export const ButtonBlue = styled(Button)(
  ({ theme }) => `
  background: ${theme.colors.primary.main};
  color: ${theme.palette.primary.contrastText};

  &:hover {
    background: ${theme.colors.primary.dark};
  }
`
);

export const DialogWrapper = styled(Dialog)(
  () => `
    .MuiDialog-paper {
      overflow: visible;
    }
    `
);

export const PrimaryTableCell = styled(TableCell)(
  ({ theme }) => `
    background: ${theme.colors.primary.main};
    color: ${theme.palette.primary.contrastText};
    text-transform: capitalize;
    font-size: 15px;
  
  `
);

export const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: ReactElement<any, any> },
  ref: Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});
